export enum VerificationError {
  ExpiredCode,
  AlreadyConfirmed,
  InvalidCode,
  LimitExceeded,
  UserNotFound,
  Unknown
}
